/* Tidel: two-panel navigation inside the "Shop All" drawer. Not part of Ella.

   The drawer itself (open/close, overlay, Esc, focus trap, scroll lock) is
   Ella's <side-drawer>; this only handles sliding between the root category
   list and a parent's sub-links, and resetting back to root on close. */
(function () {
  'use strict';

  var DRAWER = '#Shop-All-Drawer';
  var PANELS = '[data-shop-all-panels]';
  var ROOT = '[data-shop-all-panel="root"]';

  function setup(panels) {
    if (panels.dataset.tidelShopAll) return;
    panels.dataset.tidelShopAll = '1';

    var root = panels.querySelector(ROOT);

    function showRoot(focusTrigger) {
      panels.classList.remove('is-child-open');
      var children = panels.querySelectorAll('.shop-all-drawer__panel--child');
      for (var i = 0; i < children.length; i++) {
        children[i].classList.remove('is-active');
        children[i].hidden = true;
      }
      var expanded = panels.querySelectorAll('[data-shop-all-open][aria-expanded="true"]');
      for (var j = 0; j < expanded.length; j++) {
        expanded[j].setAttribute('aria-expanded', 'false');
      }
      if (root) root.hidden = false;
      if (focusTrigger && typeof focusTrigger.focus === 'function') focusTrigger.focus();
    }

    panels.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-shop-all-open]');
      if (opener) {
        var panel = panels.querySelector('#' + CSS.escape(opener.getAttribute('data-shop-all-open')));
        if (!panel) return;
        panel.hidden = false;
        // Next frame, so the transition runs from its off-screen start position.
        requestAnimationFrame(function () {
          panel.classList.add('is-active');
          panels.classList.add('is-child-open');
        });
        opener.setAttribute('aria-expanded', 'true');
        var back = panel.querySelector('[data-shop-all-back]');
        if (back) back.focus();
        // Once the slide finishes, take the root list out of the tab order so
        // the drawer's focus trap cannot reach links hidden behind this panel.
        window.setTimeout(function () {
          if (root && panel.classList.contains('is-active')) root.hidden = true;
        }, 300);
        return;
      }

      if (event.target.closest('[data-shop-all-back]')) {
        var current = event.target.closest('.shop-all-drawer__panel--child');
        var trigger = current
          ? panels.querySelector('[data-shop-all-open="' + current.id + '"]')
          : null;
        if (root) root.hidden = false;   // back in the tab order before the slide
        panels.classList.remove('is-child-open');
        if (current) {
          current.classList.remove('is-active');
          // Keep it in the DOM until the slide-out finishes.
          window.setTimeout(function () {
            if (!current.classList.contains('is-active')) current.hidden = true;
          }, 300);
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (trigger && typeof trigger.focus === 'function') trigger.focus();
      }
    });

    // Reset to the root list whenever the drawer is closed, so it reopens clean.
    var drawer = panels.closest('side-drawer');
    if (drawer && typeof MutationObserver === 'function') {
      var wasOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('active');
        if (wasOpen && !isOpen) showRoot(null);
        wasOpen = isOpen;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function boot() {
    var drawer = document.querySelector(DRAWER);
    if (!drawer) return;
    var panels = drawer.querySelector(PANELS);
    if (panels) setup(panels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // <side-drawer> relocates itself to <body> on connect, and the theme editor
  // re-renders sections, so re-run on both.
  document.addEventListener('shopify:section:load', boot);
})();
